import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import AnimateNumber, {
  AnimateNumberFomat,
} from '@components/animations/animate-number';

import Percentage from './percentage';
import RefIndicator from './ref-indicator';
import ComingSoonPill from '@components/basics/coming-soon-pill';

interface MetricIndicatorProps {
  className?: string;
  label?: number;
  value?: number;
  refText?: React.ReactNode;
  refOpacity?: number;
  labelFormat?: AnimateNumberFomat;
  valueFormat?: AnimateNumberFomat;
  noAnimation?: boolean;
  textTop?: boolean;
  isVertical?: boolean;
  isRed?: boolean;
  isGrey?: boolean;
  hidePercentage?: boolean;
  isComingSoon?: boolean;
  indicatorColor?: 'grey' | 'accent' | 'warning' | string; //string for hex color
}

const MetricIndicator: FunctionComponent<MetricIndicatorProps> = ({
  className,
  label,
  value,
  refText,
  refOpacity,
  labelFormat,
  valueFormat,
  noAnimation,
  textTop,
  isVertical,
  isRed,
  isGrey,
  hidePercentage,
  indicatorColor,
  isComingSoon,
}) => {
  return (
    <div className={className || ''}>
      {(refText && isVertical) || textTop ? (
        <RefIndicator
          color={label ? indicatorColor : 'grey'}
          circleOpacity={refOpacity}
          label={refText}
          marginBottom
          isBorder={isComingSoon}
        />
      ) : null}
      <MetricHeader className={isVertical ? 'vertical' : ''}>
        {isComingSoon ? (
          <ComingSoonPill />
        ) : (
          <Typography
            className={`metric-number ${
              (!label && isGrey) || isComingSoon ? 'grey' : ''
            } ${label && isRed ? 'red' : ''}`}
            customFont="semi-bold"
          >
            {typeof label === 'number' && labelFormat !== 'money' ? (
              label
            ) : label ? (
              <AnimateNumber
                from={0}
                to={label}
                format={labelFormat}
                noAnimation={noAnimation}
              />
            ) : (
              '$0.00'
            )}
          </Typography>
        )}
        {isComingSoon
          ? null
          : !hidePercentage && (
              <Percentage
                value={value ? value : 0}
                valueFormat={valueFormat}
                noAnimation={noAnimation}
                isRed={isRed}
              />
            )}
      </MetricHeader>
      {refText && !isVertical && !textTop ? (
        <RefIndicator
          color={indicatorColor}
          circleOpacity={refOpacity}
          label={refText}
          isBorder={isComingSoon}
        />
      ) : null}
    </div>
  );
};

export default styled(MetricIndicator)``;

const MetricHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;

  &.vertical {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .metric-number {
    font-size: ${({ theme }) => theme.typography.sectionTitle};

    &.red {
      color: ${({ theme }) => theme.colors.accent};
    }

    &.grey {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;
